import './about.css'

const About = () => {
  return (
    <>
      <h2>About Alex</h2>
      <div className="headshotleft" >
        <img
          src="/images/alexm-IMG_4485_web.jpeg"
          alt="Alex Mallory headshot"
          style={{
            maxWidth: "100%",
            width: "400px",
            marginRight: 15
          }}
        />

        <p>
          <em>Headshot by Tyler Core.</em>
        </p>
      </div>
      <div>
        <p>
          Alex Mallory is the director of The Metal Shop Performance Lab,
          founded with the mission to create theatrical events that foster
          radical community-building and authentic exchange between artists
          and audiences, and half of the new artistic collaboration JunkHeart,
          creating bigger worlds for people to witness so they have bigger worlds to exist within.
        </p>

        <p>
          Chicago directing highlights include the Jeff-nominated, extended world premiere of THE CAVE
          by Sadieh Rifai for A Red Orchid Theatre in Chicago, a community-engaged touring production of MY NAME IS RACHEL CORRIE,
          WITCH for DePaul University, and MARY STUART and an original adaptation of SPRING AWAKENING at Northwestern University.
          Assisting credits include Steppenwolf, Lookingglass, Goodman, and the Oregon Shakespeare Festival.
        </p>
        <p>
          New York highlights include GOLIATH by Takeo Rivera, DIJLA WAL FURAT: BETWEEN THE TIGRIS AND THE EUPHRATES by Maurice Decaul,
          and Caroline Rothstein's one-woman shows FAITH and COME INSIDE, all produced by Poetic Theater Productions where she
          served as Co-Artistic Director from 2011-2015.

          In NYC, Alex directed the Women Center Stage Initiative
          for the mission-based non-profit theater company Culture Project in 2013 & 2014,
          and directed and developed new plays with Lincoln Center, BEDLAM, The Working Theatre,
          Classical Theater of Harlem, Dixon Place, Writopia Worldwide Plays Festival, the Samuel French Short
          Play Festival, and The Eagle Project.

        </p>

        <p>
          Alex has worked closely with the military veteran community as a facilitator for DE-CRUIT Inc.,
          as Senior Producer for the Veteran Artist Program in NYC,
          and as a director for The Telling Project in communities spanning the country from Shelter Island to Stanford University.
          In 2016 she was honored by the LaGuardia Community College Veterans Upward Bound program for continued service to the veteran community.
        </p>

        <p>
          Alex holds an MFA in Directing from Northwestern University and a BA
          from Stanford University where she received the Louis Sudler Prize
          in Creative Arts and the Sherifa Omade Edoga Prize for work
          involving social issues.
        </p>
        <p>
          She is a proud union member of the Stage Directors and Choreographers Society (SDC).
        </p>
      </div>
    </>
  );
};
export default About;
